import { jsx as _jsx } from "react/jsx-runtime";
import { Combobox } from '@/components/ui/combobox';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
/**
 * Type-ahead clinic picker (value = clinic id). Thin wrapper over Combobox
 * that maps clinics to options and supplies the clinic wording; pass
 * `allOption` for filters ("All clinics").
 */
export function ClinicCombobox({ clinics, placeholder, ...rest }) {
    const { t } = useTranslation();
    const options = useMemo(() => clinics.map((c) => ({ value: c.clinicId, label: c.clinicName })), [clinics]);
    return (_jsx(Combobox, { ...rest, options: options, placeholder: placeholder ?? t('clinicPicker.placeholder'), noMatchText: t('clinicPicker.noMatch') }));
}
